export default __webpack_public_path__ + "static/media/smile.a24fc214.png";